import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-cms/empty@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-4cb88328"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "授权用户管理", -1));
const _hoisted_2 = {
  class: "tip"
};
const _hoisted_3 = {
  key: 0,
  class: "no-result"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "empty-img",
  src: _imports_0
}, null, -1));
const _hoisted_5 = {
  key: 1,
  class: "table"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "授权用户筛选", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select"
}, "机构名称/机构ID", -1));
const _hoisted_8 = {
  class: "input-with-select"
};
const _hoisted_9 = {
  style: {
    "padding": "0 16px"
  }
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select"
}, "筛选时间", -1));
const _hoisted_12 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_space = _resolveComponent("el-space");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_Pagination = _resolveComponent("Pagination");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    class: "el-authorization-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "el-authorization-header"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
        id: "content"
      }, () => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createTextVNode(" 使用开发者令牌、密钥和机构ID，可向指定的机构内新增授权用户，详情请参见 "), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => _ctx.openDoc())
      }, "开发与帮助文档")])], true)]),
      _: 3
    }), _createVNode(_component_el_main, {
      class: "el-authorization-main"
    }, {
      default: _withCtx(() => [_ctx.authorizationUserList.length === 0 && _ctx.showPage && _ctx.isGetAllList && !_ctx.isSearch ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, null, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          class: "no-result-title"
        }, {
          default: _withCtx(() => [_createTextVNode("暂无数据")]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), (_ctx.authorizationUserList.length > 0 || _ctx.isSearch) && _ctx.showPage && _ctx.isGetAllList ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_space, {
          wrap: "",
          size: "large"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "condition-col"
          }, {
            default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
              modelValue: _ctx.conditionCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.conditionCode = $event),
              class: "condition-select",
              onChange: _cache[2] || (_cache[2] = $event => _ctx.changeCondition())
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "机构名称",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "机构ID",
                value: "2"
              })]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: _ctx.inputValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.inputValue = $event),
              clearable: "",
              class: "condition-input"
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_col, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "user-id",
              modelValue: _ctx.openId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.openId = $event),
              placeholder: "请输入用户ID",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "btn-col"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = $event => _ctx.search())
            }, {
              default: _withCtx(() => [_createTextVNode("查询")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
        class: _normalizeClass(["user-table", {
          emptyTable: _ctx.authorizationUserList.length === 0
        }]),
        data: _ctx.authorizationUserList
      }, {
        empty: _withCtx(() => [_createVNode(_component_el_empty, {
          description: "暂无数据",
          "image-size": _ctx.userTableHeight / 2.5
        }, null, 8, ["image-size"])]),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "orgName",
          label: "机构名称",
          "min-width": "13%",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "orgId",
          label: "机构ID",
          "min-width": "20%",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "openId",
          label: "用户ID",
          "min-width": "16%",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "min-width": "19%",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "expDate",
          label: "到期时间",
          "min-width": "19%",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "10%",
          "class-name": "handle"
        }, {
          default: _withCtx(scop => [_createElementVNode("span", {
            onClick: $event => _ctx.showLog(scop),
            style: {
              "-webkit-tap-highlight-color": "transparent",
              "-moz-tap-highlight-color": "transparent"
            }
          }, "查看日志", 8, _hoisted_10)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "class"])]), _withDirectives(_createVNode(_component_Pagination, {
        totalCount: _ctx.totalCount,
        onOnChange: _cache[6] || (_cache[6] = $event => _ctx.change($event))
      }, null, 8, ["totalCount"]), [[_vShow, _ctx.authorizationUserList.length > 0]])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogTableVisible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.dialogTableVisible = $event),
        title: "用户日志",
        width: "80%",
        "close-on-click-modal": false,
        onOpened: _cache[11] || (_cache[11] = $event => _ctx.dialogOpened()),
        onClose: _cache[12] || (_cache[12] = $event => _ctx.closeDialog())
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          style: {
            "margin-bottom": "16px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_space, {
            wrap: "",
            size: "large"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, null, {
              default: _withCtx(() => [_hoisted_11, _ctx.showDatePicker ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 0,
                class: "log-date-picker",
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.value = $event),
                type: "daterange",
                "start-placeholder": "开始时间",
                "range-separator": "至",
                "end-placeholder": "结束时间",
                editable: false,
                onChange: _ctx.getDaterange
              }, null, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "search-btn"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[8] || (_cache[8] = $event => _ctx.getUserLogList(1))
              }, {
                default: _withCtx(() => [_createTextVNode("查询")]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", {
          class: _normalizeClass(["log-table", {
            loadingLength: !_ctx.isGetLogList
          }])
        }, [_ctx.isGetLogList ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.userLogList,
          "max-height": "260",
          class: _normalizeClass({
            emptyTable: _ctx.userLogList.length === 0
          })
        }, {
          empty: _withCtx(() => [_createVNode(_component_el_empty, {
            description: "暂无数据",
            "image-size": 80
          })]),
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "orgName",
            label: "机构名称",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            prop: "orgId",
            label: "机构ID",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            prop: "openId",
            label: "用户ID",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "时间",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "城市",
            "show-overflow-tooltip": true
          }, {
            default: _withCtx(scop => [_createTextVNode(_toDisplayString(_ctx.getAddress(scop.row)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "ipAddr",
            label: "IP",
            "show-overflow-tooltip": true
          }, {
            default: _withCtx(scop => [_createTextVNode(_toDisplayString(_ctx.getIp(scop)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "device",
            label: "设备",
            "show-overflow-tooltip": true
          }, {
            default: _withCtx(scop => [_createTextVNode(_toDisplayString(scop.row.device.osName) + " " + _toDisplayString(scop.row.device.browserName), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "对象",
            "show-overflow-tooltip": true
          }, {
            default: _withCtx(scop => [_createElementVNode("span", {
              class: "componentName",
              onClick: $event => _ctx.previewComponent(scop)
            }, _toDisplayString(scop.row.componentName), 9, _hoisted_12)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "class"])) : _createCommentVNode("", true)], 2), _withDirectives(_createVNode(_component_Pagination, {
          class: "log-pagination",
          totalCount: _ctx.logTotalCount,
          onOnChange: _cache[9] || (_cache[9] = $event => _ctx.logListchange($event))
        }, null, 8, ["totalCount"]), [[_vShow, _ctx.userLogList.length > 0]])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 3
  });
}